import type { RichContent } from '@wix/ricos';
import { GIFData_GIFType, Node_Type, createParagraphNode } from '@wix/ricos';

export class ContentCreator {
  content: RichContent;
  entityIdx: number;
  constructor() {
    this.content = {
      nodes: [
        {
          type: Node_Type.PARAGRAPH,
          id: '4d6hu1',
          nodes: [],
          paragraphData: {},
        },
      ],
      metadata: {
        version: 1,
        createdTimestamp: new Date(),
        updatedTimestamp: new Date(),
        id: '00c7fed7-27c1-4633-a0b5-159d32dd41fc',
      },
      documentStyle: {},
    };

    this.entityIdx = 0;
  }

  get json() {
    return this.content;
  }

  addText = (text: string) => {
    const node = createParagraphNode([
      {
        type: Node_Type.TEXT,
        id: String(Date.now()),
        nodes: [],
        textData: {
          text,
          decorations: [],
        },
      },
    ]);
    this.content = {
      ...this.content,
      nodes: [...(this.content.nodes ?? []), node],
    };
  };

  addContentErrorMessage = ({
    content,
    error,
    componentStack,
  }: {
    content?: RichContent;
    error: Error;
    componentStack: string;
  }) => {
    this.addGif();
    this.addText(
      'So sorry to inform you, there was some error with the content you planned on displaying here...'
    );
    content && this.addText(`The content: ${JSON.stringify(content)}`);
    this.addText(`crashed with: ${error.toString()}`);
    this.addText('(more details in console)');
    this.addText(componentStack.slice(0, 1000));
  };

  addGif = () => {
    const gifNode = {
      type: Node_Type.GIF,
      id: 'laswi3',
      nodes: [],
      gifData: {
        containerData: {
          width: {
            size: 'CONTENT' as any,
          },
          alignment: 'CENTER' as any,
          textWrap: true,
        },
        original: {
          gif: 'https://media2.giphy.com/media/GDnomdqpSHlIs/giphy.gif?cid=558f2fbelp6irnt12j1wq31tdfc95763yzt6mxet4jh5tv8m&rid=giphy.gif',
          mp4: 'https://media2.giphy.com/media/GDnomdqpSHlIs/giphy.mp4?cid=558f2fbelp6irnt12j1wq31tdfc95763yzt6mxet4jh5tv8m&rid=giphy.mp4',
          still:
            'https://media2.giphy.com/media/GDnomdqpSHlIs/giphy_s.gif?cid=558f2fbelp6irnt12j1wq31tdfc95763yzt6mxet4jh5tv8m&rid=giphy_s.gif',
        },
        downsized: {
          gif: 'https://media2.giphy.com/media/GDnomdqpSHlIs/giphy.gif?cid=558f2fbelp6irnt12j1wq31tdfc95763yzt6mxet4jh5tv8m&rid=giphy.gif',
          mp4: 'https://media2.giphy.com/media/GDnomdqpSHlIs/giphy-downsized-small.mp4?cid=558f2fbelp6irnt12j1wq31tdfc95763yzt6mxet4jh5tv8m&rid=giphy-downsized-small.mp4',
          still:
            'https://media2.giphy.com/media/GDnomdqpSHlIs/giphy_s.gif?cid=558f2fbelp6irnt12j1wq31tdfc95763yzt6mxet4jh5tv8m&rid=giphy_s.gif',
        },
        height: 282,
        width: 500,
        gifType: GIFData_GIFType.NORMAL,
      },
    };

    this.content = {
      ...this.content,
      nodes: [...(this.content.nodes ?? []), gifNode],
    };
  };
}
